import React, { useEffect, Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { SearchPatients } from "../../../../api/opd/patientSearchAPI";

const ListPatientSearch = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [searchIn, setSearchIn] = useState("Patient Name");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchOpds = async (search = "", searchIn = "") => {
    dispatch({ type: "LOADER_START" });
    try {
      const response = await SearchPatients({ search, searchIn }); // Your API should return a list of OPD entries
      if (response.success) {
        showToast("success", response.message);
        const formattedData = response.data.map((item, index) => ({
          index: index + 1,
          id: item._id,
          opdNo: item.opdNo || "",
          uhidNo: item.patientId?.uhidNo || "",
          date: item.date ? new Date(item.date).toLocaleDateString() : "",
          patientName:
            (item.patientId?.patientNamePrefix ? item.patientId?.patientNamePrefix + " " : "") +
            (item.patientId?.patientName || ""),
          sex: item.patientId?.sex || "",
          age: item.patientId?.age ? `${item.patientId?.age} ${item.patientId?.ageSuffix || ""}` : "",
          bloodGroup: item.patientId?.bloodGroup || "",
          mobileNo: item.patientId?.mobileNo || "",
          phoneNo: item.patientId?.phoneNo || "",
          address: item.patientId?.address || "",
          guardianName: item.patientId?.guardianName || "",

          referenceDoctor: item.referenceDoctorId?.name || "",
          consultantDoctor: item.consultantDoctorId?.name || "",
          department: item.departmentId?.name || "",
          case: item.caseId?.name || "",
          casually: item.casually || "No",
          foreiger: item.foreiger || "No",
          amount: item.amount || 0,
          discountAmount: item.discountAmount || 0,
          netAmount: item.netAmount || 0,
        }));
        setData(formattedData);
        setFilteredData(formattedData);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  // useEffect(() => {
  //   fetchOpds();
  // }, []);

  const handleSearch = () => {
    if (!search) {
      Swal.fire("Error", "Please enter search term", "error");
    }

    if (search && searchIn) {
      fetchOpds(search, searchIn);
    }  
  }


  const columns = [
    { name: "S.No", selector: row => row.index, sortable: true, width: "8%" },
    { name: "OPD No", selector: row => row.opdNo, sortable: true, width: "10%" },
    { name: "UHID No", selector: row => row.uhidNo, sortable: true, width: "10%" },
    { name: "Date", selector: row => row.date, sortable: true, width: "10%" },
    { name: "Patient Name", selector: row => row.patientName, sortable: true, width: "15%" },
    { name: "Sex", selector: row => row.sex, width: "10%" },
    { name: "Age", selector: row => row.age, width: "10%" },
    { name: "Blood Group", selector: row => row.bloodGroup, width: "10%" },
    { name: "Mobile No", selector: row => row.mobileNo, width: "10%" },
    { name: "Phone No", selector: row => row.phoneNo, width: "10%" },
    { name: "Address", selector: row => row.address, width: "15%" },
    { name: "Guardian Name", selector: row => row.guardianName, width: "15%" },
    { name: "Reference Doctor", selector: row => row.referenceDoctor, width: "15%" },
    { name: "Consultant Doctor", selector: row => row.consultantDoctor, width: "15%" },
    { name: "Department", selector: row => row.department, width: "10%" },
    { name: "Case", selector: row => row.case, width: "10%" },
    { name: "Net Amount", selector: row => row.netAmount, sortable: true, width: "15%" },
    // {
    //   name: "Actions",
    //   cell: row => (
    //     <div>
    //       <button
    //         className="btn btn-primary me-2"
    //         onClick={() => handleEditClick(row.id)}
    //         id={`edit-${row.id}`}
    //       >
    //         <i className="fa fa-pencil-square-o" />
    //       </button>
    //       <UncontrolledTooltip placement="top" target={`edit-${row.id}`}>
    //         Edit
    //       </UncontrolledTooltip>

    //       <button
    //         className="btn btn-danger"
    //         onClick={() => handleDeleteClick(row.id)}
    //         id={`delete-${row.id}`}
    //       >
    //         <i className="fa fa-trash-o" />
    //       </button>
    //       <UncontrolledTooltip placement="top" target={`delete-${row.id}`}>
    //         Delete
    //       </UncontrolledTooltip>
    //     </div>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    //   width: "20%"
    // }
  ];

  const headers = [
    { label: "S.No", key: "index" },
    { label: "OPD No", key: "opdNo" },
    { label: "UHID No", key: "uhidNo" },
    { label: "Date", key: "date" },
    { label: "Patient Name", key: "patientName" },
    { label: "Sex", key: "sex" },
    { label: "Age", key: "age" },
    { label: "Blood Group", key: "bloodGroup" },
    { label: "Phone No", key: "phoneNo" },
    { label: "Mobile No", key: "mobileNo" },
    { label: "Address", key: "address" },
    { label: "Guardian Name", key: "guardianName" },
    { label: "Reference Doctor", key: "referenceDoctor" },
    { label: "Consultant Doctor", key: "consultantDoctor" },
    { label: "Department", key: "department" },
    { label: "Case", key: "case" },
    { label: "Casually", key: "casually" },
    { label: "Foreigner", key: "foreiger" },
    { label: "Amount", key: "amount" },
    { label: "Discount", key: "discountAmount" },
    { label: "Net Amount", key: "netAmount" }
  ];

  const ExportCSV = ({ data }) => (
    <CSVLink data={data} headers={headers} filename="patients.csv">
      <button 
        className="btn btn-primary mt-1" 
        id="export"
        >
        Export
      </button>
      <UncontrolledTooltip placement="top" target="export">
        Export to CSV
      </UncontrolledTooltip>
    </CSVLink>
  );

  return (
    <Fragment>
      <Breadcrumb parent="Patients" title="Search Patient" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-sm-4">
                    <label>Search</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search Patients..."
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                      style={{ marginTop: "5px" }}
                    />
                  </div>
                  <div className="col-sm-4">
                    <label>In</label>
                    <select
                      className="form-control"
                      style={{ marginTop: "5px" }}
                      onChange={e => setSearchIn(e.target.value)}
                      value={searchIn}
                    >
                      <option value="Patient Name">Patient Name</option>
                      <option value="Guardian">Guardian</option>
                      <option value="Address">Address</option>
                      <option value="Mobile No">Mobile No</option>
                      <option value="Phone No">Phone No</option>
                      <option value="Blood Group">Blood Group</option>
                      <option value="Aadhar Card No">Aadhar Card No</option>
                      <option value="Voter ID">Voter ID</option>
                      <option value="Ration Card No">Ration Card No</option>
                      <option value="BPL No">BPL No</option>
                      <option value="PAN No">PAN No</option>
                      <option value="Driving License No">Driving License No</option>
                    </select>
                  </div>
                  <div className="col-sm-2">
                    <button
                      id="search"
                      className="btn btn-primary"
                      style={{ marginTop: "35px" }}
                      onClick={() => handleSearch()}
                    >
                      Search
                    </button>
                    <UncontrolledTooltip placement="top" target="search">
                      Search Patient
                    </UncontrolledTooltip>
                  </div>
                  <div className="col-sm-2 text-end">
                    <ExportCSV data={data} />
                  </div>
                </div>
              </div>

              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  highlightOnHover
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ListPatientSearch;
